import React , { useState } from 'react'

const ContactFormContext = React.createContext()

function ContactFormContextProvider({ children }){
    const [openContact, setOpenContact] = useState(false);
    const handleOpenContact = (val) => setOpenContact(val);


    return (
      <ContactFormContext.Provider
        value={{
          openContact,
          handleOpenContact,
        }}
      >
        {children}
      </ContactFormContext.Provider>
    );
}

export { ContactFormContext, ContactFormContextProvider }